import DataReport from '@/pages/DataReport';

/**
 * "Past Data" currently reuses Data Report UI/data source.
 * Kept as a separate route so the sidebar can expose it as a distinct page label.
 */
export default function PastData() {
  return <DataReport />;
}
